import OnboardingButton from './OnboardingButton'

export default OnboardingButton
